// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

const punto = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/punto`
    ,
    state: {
        punto: null,
        puntos: null
        , puntoscategoria: []
        , puntoscategoriaentidad: []
        , puntoscategoriaAllsector: []
        , puntosavanceAllsector: []
    }
}).get({
    property: "actual",
    action: "punto",
    path: ({ id }) => `/${id}`
}).get({
    action: "get_puntos",
    onSuccess: (state, payload) => {
        state.puntos = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "GetPunto",
    path: function (obj) {
        return `/${obj.idpunto}`;
    },
    onSuccess: (state, payload) => {
        state.punto = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "puntoTodos",
    path: function (obj) {
        if (obj.idclasificacion == null) {
            return `/detalle/${obj.periodoId}`;
        }
        else {
            return `/detalle/${obj.periodoId}/idclasificacion=${obj.idclasificacion}`;
        }
    },
    onSuccess: (state, payload) => {
        // if you set the onSuccess function you have to set the state manually        
        state.puntos = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.puntos = [];
    }
}).get({
    action: "puntoPND",
    path: function (obj) {
        return `/pnd/${obj.idplannacionaldesarrollo}`;
    },
    onSuccess: (state, payload) => {
        // if you set the onSuccess function you have to set the state manually        
        state.puntos = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.puntos = [];
    }
})
    .get({
        action: "get_puntossector",
        path: function (obj) {
            return `/detalle/${obj.periodoId}/idsector=${obj.idsector}`;
        },
        onSuccess: (state, payload) => {
            state.puntoscategoria = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_puntosentidad",
        path: function (obj) {
            return `/detalle/${obj.periodoId}/identidad=${obj.identidad}`;
        },
        onSuccess: (state, payload) => {
            // if you set the onSuccess function you have to set the state manually
            state.puntoscategoriaentidad = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_puntosAllsector",
        path: function (obj) {
            return `/detalleallsector/${obj.periodoId}`;
        },
        onSuccess: (state, payload) => {
            state.puntoscategoriaAllsector = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).get({
        action: "get_puntosavanceAllsector",
        path: function (obj) {
            return `/allsector/${obj.periodoId}`;
        },
        onSuccess: (state, payload) => {
            state.puntosavanceAllsector = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }) 
    .get({
        action: "get_puntosbyusuario",
        path: function () {
            return `/usuario`;
        },
        onSuccess: (state, payload) => {
            state.puntos = payload.data;
        },
        onError: (state, error) => {
            store.dispatch("mensaje/set_error", error);
        }
    }).post({
        property: "actual",
        action: "puntoActualizar",
        path: ({ id }) => `/puntos/${id}`
    })
    .getStore();


punto.getters = {
    gpunto: state => {
        return state.punto
    },
    gpuntos: state => {
        return state.puntos
    },
    gpuntoscategoria: state => {
        return state.puntoscategoria
    },
    gpuntoscategoriaentidad: state => {
        return state.puntoscategoriaentidad
    },
    gpuntosAllsectores: state => {
        return state.puntoscategoriaAllsector
    },
    gpuntosavancesAllsectores: state => {
        return state.puntosavanceAllsector
    }
}

export default punto;